<template>
  <sui-page>
    <sui-page-header title="등록화면"></sui-page-header>
    <sui-page-contents>

      <!-- Block 1 (S) -->
      <sui-panel title="설비대상 지정">
        <div class="comm_scr_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="selectbox"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-select-box :value="{ label: '', key: '' }" :option-list="[{ label: 'select001 ', key: '' }, { label: 'select0002', key: '' }, { label: 'select00003', key: '' }, { label: 'select000000000000004', key: '' }]" placeholder="selectbox">
              </sui-select-box>
              <div class="comp_spacing"></div>
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" ></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="text-field" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="text-field" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false"></sui-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
                <sui-input-label label="checkbox"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-checkbox v-model="multiCheckbox" value="Chk1">Chk1</sui-checkbox>
              <sui-checkbox v-model="multiCheckbox" value="Chk2">Chk2</sui-checkbox>
              <sui-checkbox v-model="multiCheckbox" value="Chk3">Chk3</sui-checkbox>
              <sui-checkbox v-model="multiCheckbox" value="Chk4">Chk4</sui-checkbox>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="radio"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-radio v-model="radioStrValue" value="radio1">Radio 1</sui-radio>
              <sui-radio v-model="radioStrValue" value="radio2">Radio 2</sui-radio>
              <sui-radio v-model="radioStrValue" value="radio3">Radio 3</sui-radio>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="date"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-date-picker :disabled="false" sticky></sui-date-picker>
            </div>
          </div>
          <div class="row">

            <div class="col-xs-1">
              <sui-input-label label="spin"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-spin :min="0" :step="1" max="10"></sui-spin>
            </div>
            <div class="col-xs-1 nodata">
            </div>
            <div class="col-xs-3">
            </div>
            <div class="col-xs-1 nodata">
            </div>
            <div class="col-xs-3">
            </div>
          </div>
          <div class="btn_wrap">
            <button type="button" class="comm_btn_Reset">초기화</button>
            <button type="button" class="comm_btn_Scr">검색</button>
          </div>
        </div>
      </sui-panel>

      <!-- Block 1 (E) -->

      <!-- Block 2 (S) -->
      <sui-panel title="설비정보">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="사업장"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <div class="comm_label">수원</div>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="상세 사업장" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
          </div>
          <div class="row">


            <div class="col-xs-1">
              <sui-input-label label="GBM" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="관리그룹"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <div class="comm_label">수원</div>
            </div>
          </div>
          <div class="row">

            <div class="col-xs-1">
              <sui-input-label label="수정자" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="수정일" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="가동일"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <div class="comm_label">2019-01-31</div>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="가동상태" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-5">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
          </div>
        </div>
        <div class="comm_title_wrap">
          <span class="sui-input-label__star"></span><h4>관리규격</h4>
          <div class="btn_wrap">
          <div class="info">CIS Spec:모터용량 37KW, 전격전압 380V, 풍량 157m/min</div>
        </div>
        </div>
        <sui-jqx-grid ref="grid" :columns="gridColumns0" :columnsautoresize="true" :autoheight="true" :dataset="'dataset0'" width="100%" pagermode="simple" :rowsheight="40"></sui-jqx-grid>
      </sui-panel>

      <!-- Block 2 (E) -->

      <!-- Block 3 (S) -->
      <sui-panel title="설정이력" sticky>
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="사업장"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <div class="comm_label">수원</div>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="상세 사업장" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="GBM" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="관리그룹"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <div class="comm_label">수원</div>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="수정자" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
            <div class="col-xs-1">
              <sui-input-label label="수정일" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label label="가동일"></sui-input-label>
            </div>
            <div class="col-xs-3">
                <div class="comm_label"> 2019-01-31</div>
             </div>
            <div class="col-xs-1">
              <sui-input-label label="가동상태" :required="true" :vertical="false"></sui-input-label>
            </div>
            <div class="col-xs-3">
              <sui-text-field placeholder="Input text" default value :disabled="false" :clearable="true" :readonly="false" style="width:100%"></sui-text-field>
            </div>
            <div class="col-xs-1 nodata">
            </div>
            <div class="col-xs-3">
             </div>
          </div>
        </div>
      </sui-panel>

      <!-- Block 3 (E) -->
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <button type="button" class="comm_btn_border">목록</button>
        </div>
        <div class="btn_wrapR">
          <button type="button" class="comm_btn_border ">저장</button>
          <button type="button" class="comm_btn_solid">결재상신</button>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
  export default {
    name: "TMP_TEM_002",
    data() {
      return {
        multiCheckbox: [],
        radioStrValue: 'radio1',
        localdata0: [
          ['1', '211', '1112111'],
          ['1', '211', '1112111'],
          ['1', '211', '1112111'],
          ['1', '211', '1112111'],
          ['1', '211', '1112111']
        ],
        gridColumns0: [{
          text: 'datafield0',
          datafield: 'datafield0'
        }, {
          text: 'datafield1',
          datafield: 'datafield1'
        }, {
          text: 'datafield2',
          datafield: 'datafield2'
        }]
      };
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
        name: 'datafield0',
        type: 'string',
        map: '0'
      }, {
        name: 'datafield1',
        type: 'string',
        map: '1'
      }, {
        name: 'datafield2',
        type: 'string',
        map: '2'
      }]
    }]
  };
</script>
<style scoped>

</style>
